import $ from 'jquery';

export const apiRequest = (url, data, method, file = false) => {
	return new Promise((resolve, reject) => {
		let props = {
			url,
			method,
			data
		};

		if (file) {
			props = {
				...props,
				contentType: 'multipart/form-data',
				processData: false
			};
		}

		$.ajax(
			props
		).done(resp => {
			if (resp.status) {
				resolve(resp);
			} else {
				reject(resp);
			}
		}).fail(reject);

	});
};

export const removeBasketItem = id => {
	return apiRequest('assets/json/removeBasketItem.json', id, 'GET');
};

export const addFavorite = id => {
	return apiRequest('assets/json/favoriteBasketItem.json', id, 'GET');
};

export const plusBasketItem = id => {
	return apiRequest('assets/json/favoriteBasketItem.json', id, 'GET');
};

export const minusBasketItem = id => {
	return apiRequest('assets/json/favoriteBasketItem.json', id, 'GET');
};

export const remined = id => {
	return apiRequest('assets/json/favoriteBasketItem.json', id, 'GET');
};

export const addItemToBasked = id => {
	return apiRequest('assets/json/autocomplete.json', id, 'GET');
};

export const removeFavoriteItem = id => {
	return apiRequest('assets/json/autocomplete.json', id, 'GET');
};

export const loadDelivery = city => {
	return apiRequest('assets/json/delivery.json', city, 'GET');
};

export const loadConditions = delivery => {
	return apiRequest('assets/json/conditions.json', delivery, 'GET');
};

export const searchCity = query => {
	return apiRequest('assets/json/autocomplete.json', query, 'GET');
};
export const cardLoyalty = query => {
	return apiRequest('assets/json/cardLoyalty.json', query, 'GET');
};
export const promoCode = query => {
	return apiRequest('assets/json/promoCode.json', query, 'GET');
};

export const subscribe = query => {
	return apiRequest('/ajax/subscription/add/', query, 'POST');
};

export const share = query => {
	return apiRequest('/ajax/email/share/', query, 'POST');
};

export const checkCardStatus = query => {
	return apiRequest('assets/json/cardBalance.json', query, 'GET');
};

export const setCard = query => {
	return apiRequest('assets/json/setCard.json', query, 'GET');
};

export const loadStories = (params, ajaxUrl) => {
	return apiRequest(ajaxUrl, params, 'POST');
};

export const question = query => {
	return apiRequest('assets/json/question.json', query, 'GET');
};

export const subscribeVacancy = query => {
	return apiRequest('assets/json/subscribeVacancy.json', query, 'GET');
};

export const sendSms = data => {
	return apiRequest('/ajax/loyaltyCard.php', data, 'POST');
};

export const addCard = data => {
	return apiRequest('/ajax/loyaltyCard.php', data, 'POST');
};

export const rebuildCard = query => {
	return apiRequest('assets/json/rebuildCard.json', query, 'GET');
};

export const sendCV = data => {
	return apiRequest('assets/json/sendCV.json', data, 'POST', true);
};

export const login = query => {
	return apiRequest('/ajax/login.php', query, 'POST');
};

export const registration = query => {
	return apiRequest('/ajax/register.php', query, 'POST');
};

export const recovery = query => {
	return apiRequest('/ajax/restore.php', query, 'POST');
};

export const atelierVisit = query => {
	return apiRequest('assets/json/atelierVisit.json', query, 'GET');
};

export const brandSubscribe = query => {
	return apiRequest('assets/json/brandSubscribe.json', query, 'GET');
};

export const emailSubscribe = query => {
	return apiRequest('assets/json/emailSubscribe.json', query, 'GET');
};

export const sizeSubscribe = query => {
	return apiRequest('assets/json/sizeSubscribe.json', query, 'GET');
};

export const showMoreJournal = query => {
	return apiRequest('/ajax/news/magazines/', query, 'POST');
};

export const saveAdress = query => {
	return apiRequest('assets/json/saveAdress.json', query, 'GET');
};

export const changeAdress = query => {
	return apiRequest('assets/json/changeAdress.json', query, 'GET');
};

export const deleteAdress = query => {
	return apiRequest('assets/json/deleteAdress.json', query, 'GET');
};

export const changeMyData = query => {
	return apiRequest('assets/json/changeMyData.json', query, 'GET');
};

export const saveMyData = query => {
	return apiRequest('assets/json/saveMyData.json', query, 'GET');
};

export const changePassword = query => {
	return apiRequest('assets/json/changePassword.json', query, 'GET');
};

export const corpLifeNews = query => {
	return apiRequest('/ajax/news/corporate-life/', query, 'POST');
};

export const canRegister = query => {
	return apiRequest('/ajax/can_register.php', query, 'POST');
};

export const getProductsByFilters = data => {
	return apiRequest('assets/json/products.json', data, 'GET', true);
};

export const querySearch = (ajaxUrl, data) => {
	return apiRequest(ajaxUrl, data, 'POST');
};

export const cardRemove = query => {
	return apiRequest('/ajax/loyaltyCard.php', query, 'GET');
};

export const getCardBalance = query => {
	return apiRequest('/ajax/loyaltyCard.php', query, 'GET');
};

export const profile = query => {
	return apiRequest('/ajax/profile.php', query, 'POST');
};



/** WEBPACK FOOTER **
 ** ./app/blocks/api/api.js
 **/